<template>

  <section>
    <div class="container blog-display">
      <div class="inner-blog">
        <div class="row">
          <div class="col-md-8">
            <div class="about-blog">
              <h1 class="blog_title">Barcelona implements Europe’s largest car ban to-date in a leap to reach WHO standard air quality</h1>
              <h2 class="blog_subhead">The proposed car ban will affect residents in Barcelona and 39 surrounding municipalities, removing more than 100,000 cars from the roads.</h2>
              <h3 class="blog_date_author">APRIL 7, 2017 - RONNIE AGYEMAN</h3>
              <div class="blog_content">
              <big>
            <p>Air pollution is a global problem requiring a global solution. </p>
            <p>The AirVisual community believes that education and awareness are the seeds of change. In order to realize a future liberated from air pollution concerns, a global understanding of the problem must be cultivated. </p>
            <p>Our online community seeks to grow awareness worldwide by providing community members no-nonsense information and access to historical, real-time and forecast air quality data. </p>
            <p>By equipping users with these tools, we believe we can change the world. The key is in cultivating a passionate community that fosters mutual collaboration. When we work together to create novel research, advice, opinions, and share monitoring data - we can begin to make a global impact. </p>
            <p>At the very heart of the community is a dynamic team of programmers, developers, designers, environmental scientists, meteorological experts and chemical engineers representing 6 countries, from 4 different continents, with 1 overarching commonality - a passion for the world we live in and the air we breathe.</p>
            <p>Each of us share a vision of a world free from air quality concerns. To realize this future, we have harnessed our passion, enthusiasm and dedication to seek a framework that fosters an organically growing community. </p>
            <p>As a crowd-sourced social enterprise - our contributors are an integral part of the team. If you share our passion, we encourage you to contribute to the cause. After all, the community is nothing without you!</p>
            </big>
            </div>
            </div><!-- end about-blog -->
          </div><!-- end col -->
          <div class="col-md-4">
            <div class="posts clearfix">
              <div class="news_block latest">
                <h4>POPULAR&nbsp;POSTS</h4>
                  <ul>
                    <li>
                        <span><a href="#"><img src="../assets/images/tower.jpg" alt="tower" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                              <small>DECEMBER 9, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>

                    <li>
                        <span><a href="#"><img src="../assets/images/map.jpg" alt="map" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">2 billion children breathing unsafe outdoor air worldwide</a></p>
                              <small>NOVEMBER 8, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>

                    <li>
                        <span><a href="#"><img src="../assets/images/east.jpg" alt="east" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">New WHO model shows 92% of world’s population breathing dangerous air</a></p>
                              <small>OCTOBER 8, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>
                  </ul>
              </div>
              </div>
          </div><!-- end col -->
        </div><!--end row -->
      </div><!-- end inner-blog -->
    </div><!-- end blog-display -->
  </section>

</template>
<script>
export default {
  name: 'newsdetails',
  data () {
    return {
      fetchedData: null,
      error: false,
      title : null
    }
  },
  mounted: function(){
      this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var itemId = this.$route.params.id;
                console.log(itemId)
                var url = 'pollution-weather'
                // axios.get(url).then(response => {
                //   if(response.status==200){
                //     var jsonData =response
                //     this.loading = false
                //     this.fetchedData = jsonData
                //     this.categories = this.getcategories(jsonData.data.data)
                //     this.pollutionData = this.getpollution(jsonData.data.data)
                //     this.weathersData = this.getweather(jsonData.data.data)
                //     if(jsonData.data.date==todayDate){
                //       this.pollutionTitle = "Pollution Data of Kathmandu for today"
                //       this.chartTitle = "Average Pollution Data of Kathmandu for today"
                //     }else{
                //       this.pollutionTitle = "Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                //       this.chartTitle = "Average Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                //     }
                //     this.options.xAxis[0].categories = this.categories
                //     this.options.series[0].data = this.pollutionData
                //     this.options.series[1].data = this.weathersData
                //     this.options.title.text = this.chartTitle
                //   }
                // })
                // .catch(e => {
                //   //this.errors.push(e)
                //   this.error = true
                // })
              }
  }
}
</script>



// WEBPACK FOOTER //
// NewsDetails.vue?5dc3ffd4